import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';
import { Col, Row } from 'react-bootstrap';
import { Button } from '@orbita-ui/core';
import { useRootLoadingSpinner } from 'shared/spinner';
import { useUserService } from 'user/services/useUserService';
import { useNotifications } from 'shared/notifications';
import { SEND_EMAIL_CONFIRMATION } from 'shared/constants/GenericMessages';
import { EmailError } from '../../../../user/services/emailErrors';

const BannerContainer = styled.div`
  background: ${ThemePrisma.colors.orange[2]};
  border-top: 1px solid #004877;
  border-left: 1px solid #004877;
  overflow: hidden;
`;

export function ConfirmBanner({ mail }: Readonly<{ mail: string }>) {
  const { addNotification } = useNotifications();
  const { setRootLoadingSpinnerStatus } = useRootLoadingSpinner();

  const userService = useUserService();

  const onSendEmail = () => {
    setRootLoadingSpinnerStatus(true);
    userService
      .registerEmail(mail)
      .then(() => {
        addNotification(SEND_EMAIL_CONFIRMATION.confirm, 'success');
      })
      .catch((error: EmailError) => {

        if (error.specificError === 'request_already_sent') {
          addNotification(SEND_EMAIL_CONFIRMATION.warning, 'warning');
        } else {
          addNotification(SEND_EMAIL_CONFIRMATION.error, 'error');
        }
      })
      .finally(() => {
        setRootLoadingSpinnerStatus(false);
      });
  };

  return (
    <BannerContainer data-testid="banner-container">
      <Row>
        <Col
          xs={12}
          xl={9}
          xxl={7}
          className="px-5 pt-4 pb-2 pb-xl-4 text-center text-xl-start d-flex align-items-center"
        >
          <p>
            Su dirección de correo electrónico <b className="fw-bold">{mail}</b>, no se
            encuentra verificada. Para verificarla, siga los pasos descritos en el correo
            que le hemos enviado.
          </p>
        </Col>
        <Col
          xs={12}
          xl={3}
          xxl={5}
          className="d-flex justify-content-center justify-content-xl-end align-items-center py-2 pb-4 pb-xl-2 pe-xl-5"
        >
          <Button
            style={{
              minWidth: 200,
            }}
            onClick={onSendEmail}
            size="small"
          >
            Enviar correo electrónico
          </Button>
        </Col>
      </Row>
    </BannerContainer>
  );
}
